var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStop = function SvgStop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "currentColor",
    style: {
      color: "#f65050"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17 30.6a13.6 13.6 0 1 0 0-27.2 13.6 13.6 0 0 0 0 27.2Zm-3.4-18.7a1.7 1.7 0 0 0-1.7 1.7v6.8a1.7 1.7 0 0 0 1.7 1.7h6.8a1.7 1.7 0 0 0 1.7-1.7v-6.8a1.7 1.7 0 0 0-1.7-1.7h-6.8Z",
    clipRule: "evenodd"
  })));
};
export default SvgStop;